import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Baneoversigt } from "./components/Baneoversigt";
import { Traeningstider } from "./components/Traeningstider";
import { Kampprogram } from "./components/Kampprogram";
import { Hold } from "./components/Hold";
import { Nyheder } from "./components/Nyheder";
import { Klubinfo } from "./components/Klubinfo";
import { Footer } from "./components/Footer";
import { AuthProvider } from "./lib/auth";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import TeamDetail from "./pages/TeamDetail";

const Home = () => {
  return (
    <div className="relative min-h-screen bg-[#0A0A0A] text-white">
      <Navbar />
      <main data-testid="main-content">
        <Hero />
        <Baneoversigt />
        <Traeningstider />
        <Kampprogram />
        <Hold />
        <Nyheder />
        <Klubinfo />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "#0A0A0A",
                border: "1px solid #262626",
                color: "#fff",
              },
            }}
          />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/hold/:teamId" element={<TeamDetail />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
